var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#F4F2FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 14.25H15.75C15.1533 14.25 14.581 14.4871 14.159 14.909C13.7371 15.331 13.5 15.9033 13.5 16.5V22.5C13.5 23.0967 13.7371 23.669 14.159 24.091C14.581 24.5129 15.1533 24.75 15.75 24.75H21.75V19.5C21.75 18.7044 22.0661 17.9413 22.6287 17.3787C23.1913 16.8161 23.9544 16.5 24.75 16.5H27C27.5287 16.5022 28.047 16.6473 28.5 16.92V16.5C28.5 15.9033 28.2629 15.331 27.841 14.909C27.419 14.4871 26.8467 14.25 26.25 14.25ZM14.25 26.25C14.0511 26.25 13.8603 26.329 13.7197 26.4697C13.579 26.6103 13.5 26.8011 13.5 27C13.5 27.1989 13.579 27.3897 13.7197 27.5303C13.8603 27.671 14.0511 27.75 14.25 27.75H22.17C21.8973 27.297 21.7522 26.7787 21.75 26.25H14.25ZM27 18H24.75C24.3522 18 23.9706 18.158 23.6893 18.4393C23.408 18.7206 23.25 19.1022 23.25 19.5V26.25C23.25 26.6478 23.408 27.0294 23.6893 27.3107C23.9706 27.592 24.3522 27.75 24.75 27.75H27C27.3978 27.75 27.7794 27.592 28.0607 27.3107C28.342 27.0294 28.5 26.6478 28.5 26.25V19.5C28.5 19.1022 28.342 18.7206 28.0607 18.4393C27.7794 18.158 27.3978 18 27 18ZM25.875 26.25C25.7267 26.25 25.5817 26.206 25.4583 26.1236C25.335 26.0412 25.2389 25.9241 25.1821 25.787C25.1253 25.65 25.1105 25.4992 25.1394 25.3537C25.1684 25.2082 25.2398 25.0746 25.3447 24.9697C25.4496 24.8648 25.5832 24.7934 25.7287 24.7644C25.8742 24.7355 26.025 24.7503 26.162 24.8071C26.2991 24.8639 26.4162 24.96 26.4986 25.0833C26.581 25.2067 26.625 25.3517 26.625 25.5C26.625 25.6989 26.546 25.8897 26.4053 26.0303C26.2647 26.171 26.0739 26.25 25.875 26.25Z",
    fill: "#7529D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.c9c2ea67835af39e8c14503651e2c379.svg";
export { ForwardRef as ReactComponent };